<template>
  <div>
    <div class="row">
      <div class="col s9">
        <div class="title" v-if="model.UserV61id">
          {{ `${$t('management.editUserTitle')} ${model.FirstName} ${model.MiddleName ? model.MiddleName : ''}
          ${model.LastName}` }}
        </div>
        <div class="title" v-if="!model.UserV61id">
          {{ `${$t('management.AddUserTitle')} ${model.FirstName} ${model.MiddleName ? model.MiddleName : ''}
          ${model.LastName}` }}
        </div>
      </div>
      <div class="col s3" v-if="!ownPage">
        <button
          type="button"
          class="waves-effect waves-light btn red"
          @click="deleteUser"
          v-if="model.UserV61id"
        >
          {{ $t('management.delete') }}
        </button>
      </div>
    </div>
    <div class="row" style="padding: 15px;">
      <div class="col s6">
        <div class="row">
          <div class="col s3 label">{{ $t('management.firstName') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="model.FirstName"
                   :placeholder="$t('management.firstName')" />
          </div>
          <div class="col s9 error" v-if="!$v.model.FirstName.required">{{$t('management.requiredfield')}}</div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.middleName') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="model.MiddleName"
                   :placeholder="$t('management.middleName')" />
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.lastName') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="model.LastName"
                   :placeholder="$t('management.lastName')" />
          </div>
          <div class="col s9 error" v-if="!$v.model.LastName.required">{{$t('management.requiredfield')}}</div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.password') }}</div>
          <div class="col s9">
            <input :type="passwordFieldType" class="browser-default" v-model="password"
                   :placeholder="$t('management.password')" />
            <a v-on:click="switchVisibility()" v-show="passwordFieldType === 'password'"><i
              class="material-icons fa-visibility">visibility</i></a>
            <a v-on:click="switchVisibility()" v-show="passwordFieldType === 'text'"><i
              class="material-icons fa-visibility_off">visibility_off</i></a>
          </div>
          <div class="col s9 error" v-if="!$v.password.strongPassword">{{$t('management.passwordcomplexity')}}</div>
        </div>
        <div class="row" v-if="!model.UserV61id">
          <div class="col s3 label">{{ $t('management.organisation') }}</div>
          <div class="col s3">
            <div class="input-field">
              <select v-model="model.OrganisationId" class="browser-default">
                <option v-for="(org, index) in organisations" :value="org.id" :key="index">
                  {{ org.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row" v-if="!ownPage">
          <div class="col s3 label">{{ $t('management.role') }}</div>
          <div class="col s3">
            <div>
              <select v-model="model.SystemRoleId" class="browser-default">
                <option v-for="role in roles" :value="role.id" :key="'role' + role.id">
                  {{ role.description }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.email') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="model.Email" :placeholder="$t('management.email')" />
          </div>
          <div class="col s9 error" v-if="!$v.model.Email.required">{{$t('management.requiredfield')}}</div>
          <div class="col s9 error" v-if="!$v.model.Email.email">{{$t('management.invalidemail')}}</div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.phone') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="model.Phone" :placeholder="$t('management.phone')" />
          </div>
          <div class="col s9 error" v-if="!$v.model.Phone.numeric">{{$t('management.notnumeric')}}</div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.mobile') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="model.MobilePhone"
                   :placeholder="$t('management.mobile')" />
          </div>
          <div class="col s9 error" v-if="!$v.model.MobilePhone.numeric">{{$t('management.notnumeric')}}</div>
        </div>
        <div class="row" v-if="!ownPage">
          <div class="col s3 label">{{ $t('management.UserStatus') }}</div>
          <div class="col s3">
            <div>
              <select v-model="model.UserStatus" class="browser-default">
                <option v-for="us in userstatus" :value="us.id" :key="'userstatus' + us.id">
                  {{ us.description }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.language') }}</div>
          <div class="col s3">
            <div class="input-field">
              <select v-model="model.LanguageId" class="browser-default">
                <option v-for="(lang, index) in locales" :value="index + 1" :key="'lang' + lang">
                  {{ lang }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col s12 right-align" style="padding: 0 50px 15px 0">
        <button
          type="button"
          class="waves-effect waves-light btn blue"
          @click="editUser"
          :disabled="$v.model.$invalid || $v.password.$invalid"
        >
          {{ $t('management.save') }}
        </button>
        <button
          type="button"
          class="waves-effect btn"
          style="background-color: #9e9e9e"
          @click="cancel"
        >
          {{ $t('management.cancel') }}
        </button>
        <div class="col s9 error" v-if="this.errored">{{this.errmsg}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import usersApi from '../../../services/api/UsersApi'
import {email, numeric, required} from 'vuelidate/lib/validators'
import sha1 from 'js-sha1'
import AuthenticationService from '../../../services/AuthenticationService'

export default {
  name: 'UserEdit',
  data () {
    return {
      errored: false,
      errmsg: 'none',
      password: null,
      passwordFieldType: 'password',
      roles: [
        {
          id: 1,
          description: this.$t('management.role.user')
        },
        {
          id: 2,
          description: this.$t('management.role.administrator')
        },
        {
          id: 3,
          description: this.$t('management.role.systemMaintainer')
        }
      ],
      userstatus: [
        {
          id: 0,
          description: this.$t('management.userstatus.inactive')
        },
        {
          id: 1,
          description: this.$t('management.userstatus.active')
        }
      ]
    }
  },
  props: {
    locales: {
      required: false
    },
    model: {
      required: true
    },
    cancelFn: {
      required: true
    },
    organisations: {
      required: false
    }
  },
  computed: {
    ownPage () {
      return AuthenticationService.getUser().UserId === this.model.UserV61id
    }
  },
  methods: {
    cancel () {
      this.cancelFn()
    },
    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    async editUser () {
      // need to hash the pass word.
      if (this.password != null) {
        this.model.PasswordHash = sha1(this.password).toString().toUpperCase()
      }
      if (this.model.UserV61id == null) {
        // new user, we've got to set some default values
        this.model.UserV61id = -1
        this.model.IsDisclaimerOk = false
        this.model.IsDisclaimerOkdatetime = null
        this.model.AccountExpires = '2025-12-31T23:59:59'
        this.model.UsergroupId = 3
        this.model.MiddleName = this.model.MiddleName || null
        this.model.MobilePhone = this.model.MobilePhone || null
        this.model.Phone = this.model.Phone || null
        this.model.IsDisclaimerOkdatetime = null
        this.model.LoginCount = 0
        this.model.LastLoginDatetime = null
        this.model.UserDepartment = []
        this.model.UserSettings = []
        this.model.UserV6Logging = []
        this.model.UserRefreshToken = []
        this.model.UserDashBoardPreset = []
        this.model.UserPermissionGroupsV7 = []
        this.model.UserVisibilityGroupsV7 = []
        this.model.Language = null
        this.model.Organisation = null
        this.model.SystemRole = null
        this.model.Usergroup = null
      }
      // need to set logonname to email
      this.model.LogonName = this.model.Email

      await usersApi.editUser(this.model)
        .then(
          result => {
            this.errored = false
            this.cancelFn()
          }
        ).catch(err => {
          this.errored = true
          this.errmsg = err.response.data
          console.log(err.response)
        })
    },
    async deleteUser () {
      if (confirm('are you sure?')) {
        await usersApi.deleteUser(this.model.UserV61id)
        this.cancelFn()
      }
    }
  },
  validations: {
    password: {
      strongPassword (password) {
        return (
          (password == null && this.model.UserV61id != null) ||
          (/[a-z]/.test(password) && // checks for a-z
            /[A-Z]/.test(password) && // checks for A-Z
            /[0-9]/.test(password) && // checks for 0-9
            /\W|_/.test(password) &&// checks for special char
            password.length >= 12)
        )
      }
    },
    model: {
      FirstName: {
        required
      },
      LastName: {
        required
      },
      Email: {
        required,
        email
      },
      Phone: {
        numeric
      },
      MobilePhone: {
        numeric
      },
      SystemRoleId: {
        required
      },
      LanguageId: {
        required
      },
      UserStatus: {
        required
      }
    }
  }
}
</script>
<style scoped>
  .title {
    font-size: x-large;
    font-weight: bold;
    padding: 1rem;
  }

  .error {
    font-size: 12px;
    color: red;
  }

  table {
    margin: -1rem 1rem;
    width: 95%;
  }

  .field-icon {
    float: right;
    margin-left: -25px;
    margin-top: -25px;
    position: relative;
    z-index: 2;
  }

</style>



// WEBPACK FOOTER //
// src/components/usermanagement/users/UserEdit.vue